import { axiosInstance } from '.';

const getCustomersList = async (params) => await axiosInstance.get('/customers', { params });

const getCustomerDetails = async ({ id }) => await axiosInstance.get(`/customers/${id}`);

const blockOrUnblockCustomer = async ({ id, data}) => await axiosInstance.patch(`/customers/${id}`, data);

export { getCustomersList, getCustomerDetails, blockOrUnblockCustomer };
